import * as yaml from 'js-yaml';

/**
 * Robust content-based parser that attempts JSON first, then YAML
 * Does not rely on file extensions for format detection
 */
export function parseInfrastructureContent(content: string, filename?: string): any {
  let parseMethod = 'unknown';
  
  try {
    // First, try to parse as JSON
    try {
      const data = JSON.parse(content);
      parseMethod = 'JSON';
      return data;
    } catch (jsonError) {
      // If JSON parsing fails, try YAML
      try {
        const data = yaml.load(content);
        parseMethod = 'YAML';
        return data;
      } catch (yamlError) {
        // If both fail, throw a comprehensive error
        throw new Error(
          `Failed to parse ${filename || 'content'} as either JSON or YAML.\n` +
          `JSON error: ${jsonError}\n` +
          `YAML error: ${yamlError}`
        );
      }
    }
  } catch (error) {
    console.error(`Error parsing ${filename || 'content'} (attempted as ${parseMethod}):`, error);
    throw error;
  }
}

/**
 * Test function to verify parsing works with various content types
 * This is primarily for development/testing purposes
 */
export function testParsingRobustness() {
  const testCases = [
    // Valid JSON
    { content: '{"test": "json"}', expected: 'JSON' },
    // Valid YAML
    { content: 'test: yaml\narray:\n  - item1\n  - item2', expected: 'YAML' },
    // JSON that could be confused with YAML
    { content: '{"key": "value", "number": 123}', expected: 'JSON' },
    // YAML that could be confused with JSON (but isn't valid JSON)
    { content: 'key: value\nnumber: 123', expected: 'YAML' },
    // Edge case: simple string that's valid YAML
    { content: 'simple string', expected: 'YAML' }
  ];

  console.log('Testing parsing robustness...');
  testCases.forEach((testCase, index) => {
    try {
      parseInfrastructureContent(testCase.content, `test-${index}`);
      console.log(`✅ Test ${index + 1}: Successfully parsed as ${testCase.expected}`);
    } catch (error) {
      console.log(`❌ Test ${index + 1}: Failed to parse - ${error}`);
    }
  });
}